var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterTopRightShapes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 567,
    height: 575,
    viewBox: "0 0 567 575",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.341 67.0819C339.382 66.8716 336.034 66.0896 332.901 65.3431C197.267 33.0032 64.0876 136.167 59.8595 276.845C56.4429 390.573 141.672 489.841 255.189 504.349C343.454 515.629 431.083 472.446 475.716 395.674C541.634 282.288 497.026 137.994 378.437 80.9985C372.584 78.1857 344.934 68.0849 340.341 67.0819ZM340.949 155.31C440.15 200.396 451.8 337.096 361.687 398.639C277.125 456.39 160.088 405.437 144.665 304.154C127.996 194.689 240.268 109.549 340.949 155.31Z",
    fill: "url(#paint0_linear_169_30464)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.94 485.488C368.591 485.123 366.914 485.797 365.597 487.635C365.256 488.11 364.954 488.961 360.545 501.847L355.856 515.552L341.988 510.872C326.591 505.675 327.792 506.028 326.19 506.233C322.521 506.703 320.17 512.604 322.439 515.65C323.578 517.181 323.403 517.109 338.895 522.373L352.023 526.834L347.261 540.941C342.784 554.204 342.498 555.084 342.477 555.674C342.38 558.367 343.59 560.059 346.395 561.151C349.533 562.373 351.846 561.86 353.498 559.577L353.959 558.941L358.775 544.856L363.591 530.772L377.363 535.42L391.136 540.069L391.947 540.111C394.733 540.256 396.328 539.059 397.358 536.055C398.4 533.016 397.981 531.162 395.877 529.504L395.219 528.986L381.323 524.234L367.427 519.483L372.044 505.806L376.661 492.129L376.684 491.344C376.771 488.331 374.528 486.044 370.94 485.488Z",
    fill: "url(#paint1_linear_169_30464)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_30464",
    x1: 71.7578,
    y1: 211.173,
    x2: 494.377,
    y2: 354.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF832A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_30464",
    x1: 321.82,
    y1: 510.728,
    x2: 397.254,
    y2: 536.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF832A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTopRightShapes);
export default __webpack_public_path__ + "static/media/Footer_Top_Right_Shapes.aaf26aed6df475a167223c72c35a0a2c.svg";
export { ForwardRef as ReactComponent };